import { render, staticRenderFns } from "./AccountSection.vue?vue&type=template&id=2f4d6c87&scoped=true&"
import script from "./AccountSection.vue?vue&type=script&lang=js&"
export * from "./AccountSection.vue?vue&type=script&lang=js&"
import style0 from "./AccountSection.vue?vue&type=style&index=0&id=2f4d6c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d6c87",
  null
  
)

export default component.exports